// extracted by mini-css-extract-plugin
module.exports = {"dialogue_wrap":"Dialogue_dialogue_wrap__beZJw","dialogue_name":"Dialogue_dialogue_name__pkZfc"};